import type { DashboardCardFormatFields } from '../types'
import type { DashboardCardDef } from '@edge/spark/io-dashboards'

const defaultDashboardCardFormatFields: DashboardCardFormatFields = {
    cardTitle: '',
    primaryDataField: 'none',
    mainLabel: '',
    mainLabel2: '',
    mainSubLabel: '',
    firstPositionDataField: 'none',
    secondPositionDataField: 'none',
    searchDetailView: 'none',
    searchDetailTitle: '',
    cardActionLabel: '',
    cardActionUrl: '',
}

/**
 * Converts a widgetDef (DashboardCardDef) to the form values (DashboardCardFormatFields)
 * Used for initial render */
export const convertDashboardCardDefToDashboardCardFormatFields = (
    widgetDef: DashboardCardDef,
): DashboardCardFormatFields => {
    if (!widgetDef.config) {
        return defaultDashboardCardFormatFields
    }

    const type = widgetDef.config?.contactLogSearch ? 'CONTACT_LOG' : 'SEARCH'
    const searchConfig = type === 'CONTACT_LOG' ? widgetDef.config?.contactLogSearch : widgetDef.config?.search

    if (!searchConfig) {
        return defaultDashboardCardFormatFields
    }

    return {
        cardTitle: widgetDef.config.title || '',

        primaryDataField: searchConfig.primary?.dataField || 'none',
        mainLabel: widgetDef.config.label || '',
        mainLabel2: widgetDef.config.label2 || '',
        mainSubLabel: widgetDef.config.sublabel || '',

        // lowerLeft dataField
        firstPositionDataField: searchConfig?.lowerLeft?.dataField || 'none',
        // lowerRight data field
        secondPositionDataField: searchConfig?.lowerRight?.dataField || 'none',

        searchDetailView: searchConfig?.searchDetailView || 'none',
        searchDetailTitle: searchConfig?.searchDetailTitle || '',

        cardActionLabel: widgetDef.config?.linklabel || '',
        cardActionUrl: widgetDef.config?.linkurl || '',
    }
}

export default convertDashboardCardDefToDashboardCardFormatFields
